<template>
  <div id="app">
    <div>
      <div class="login_maxBox">
        <div class="container login_box center-block regist">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            class="fifth table-list"
          >
            <el-tab-pane
              label="邮件注册"
              name="first"
              class="ten"
              v-if="isEmail"
            >
              <el-form
                ref="form"
                :model="form"
                label-width="80px"
                class="twenfive"
              >
                <el-form-item label="Email:">
                  <el-col :lg="13" :xl="13" :md="13" :sm="13">
                    <el-input
                      :disabled="isshuru"
                      v-model="form.name"
                      placeholder="请输入E-mail"
                      @blur="DetectInput($event, 'emails')"
                      @input="DetectKey($event, 'emails')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="10"
                    :lg="10"
                    :xl="10"
                    :sm="10"
                    class="leftfloat ml1 myzm"
                    v-if="iscodeBtn"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="Btn"
                    ></el-button>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                    v-if="isshurus"
                  >
                    <el-button type="primary" plain @click="aaa()"
                      >验证该邮箱是否可用</el-button
                    >
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="msg_error" v-html="EmailTiShi"></div>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    本系统是工作系统，经常会和作者联系，请填写经常使用的邮箱。
                  </div>
                </el-form-item>
                <div v-if="isShows">
                  <el-form-item label="验证码:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcodes"
                        placeholder="请输入验证码"
                        @blur="DetectInput($event, 'codes')"
                        @input="DetectKey($event, 'codes')"
                      ></el-input>
                      <div class="msg_error" v-html="codeTishi"></div>
                    </el-col>
                    <el-col
                      :md="6"
                      :lg="6"
                      :xl="6"
                      :sm="6"
                      class="leftfloat ml1 myzm"
                    >
                      <span style="cursor: pointer">
                        <img
                          @click="initVeri()"
                          :src="'data:image/png;base64,' + Picturebase"
                          alt="无效"
                        />
                      </span>
                    </el-col>
                  </el-form-item>
                  <div class="clearfix"></div>
                  <div class="msg_error" v-html="codeTiShis"></div>

                  <div class="twenfive">
                    <div class="msg_error" v-if="statuCf">
                      该邮箱已被人注册。如果您确认该邮箱是您的邮箱，可<a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >找回密码</a
                      >。
                    </div>
                    <div class="msg_error" v-if="statuCfa">
                      该邮箱已被人注册。如果您确认该邮箱是您的邮箱，请您<a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >找回密码</a
                      >或致电页面底部技术支持。
                    </div>
                    <div class="highgreen" v-if="status == 1">
                      系统已经发送验证码到填写的邮箱，若未收到验证码，请到邮件垃圾箱中查找一下。
                    </div>
                  </div>
                  <div class="twenfive">
                    <el-col
                      :md="10"
                      :lg="10"
                      :xl="10"
                      :sm="10"
                      class="leftfloat ml1 myzm"
                      v-if="iscodeBtna"
                    >
                      <el-button
                        class="five"
                        type="primary"
                        plain
                        @click="sendCodeBtn"
                        v-html="Btn1"
                        style="width: 100%"
                      ></el-button>
                    </el-col>
                    <el-col
                      :md="10"
                      :lg="10"
                      :xl="10"
                      :sm="10"
                      class="leftfloat ml1 myzm"
                    >
                      <el-button
                        class="five"
                        style="width: 100%"
                        v-if="status == 0"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                    </el-col>
                  </div>
                  <template v-if="status == 1">
                    <el-form-item label="验证码:">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="请输入验证码"
                        ></el-input>
                        <div class="msg_error" v-html="codeTishi"></div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="密码:">
                      <el-col
                        :md="14"
                        :lg="14"
                        :xl="14"
                        style="margin-top: 10px"
                      >
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          @blur="DetectInput($event, 'pass')"
                          @input="DetectKey($event, 'pass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="five highgray five" style="zoom: normal">
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）</span
                        >
                      </div>
                      <div class="msg_error" v-html="pwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="确认密码:">
                      <el-col
                        :md="14"
                        :lg="14"
                        :xl="14"
                        style="margin-bottom: 10px"
                      >
                        <el-input
                          v-model="form.rpass"
                          placeholder="请重新输入您的密码"
                          @blur="DetectInput($event, 'rpass')"
                          @input="DetectKey($event, 'rpass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="rpwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="submit()"
                        >提交</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                      <div class="highgreen ten" v-if="showsuess">
                        <i class="el-icon-success"></i>提交成功！
                        <a href="javascript:;" class="highblue ml15"
                          >登录后完善个人信息后，投稿。</a
                        >
                      </div>
                    </el-form-item>
                  </template>
                </div>
              </el-form>
            </el-tab-pane>

            <el-tab-pane
              label="手机注册"
              name="second"
              class="ten"
              v-if="isphones"
            >
              <el-form
                ref="form"
                :model="form"
                label-width="80px"
                class="twenfive"
              >
                <el-form-item label="手机号:">
                  <el-col :md="14" :lg="14" :xl="14" :sm="12">
                    <el-input
                      v-model="form.name"
                      :disabled="isshuru"
                      placeholder="请输入手机号码"
                      @blur="DetectInput($event, 'phone')"
                      @input="DetectKey($event, 'phone')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                    v-if="isshurus"
                  >
                    <el-button type="primary" plain @click="aaa()"
                      >验证该手机号是否可用</el-button
                    >
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="msg_error" v-html="phoneTiShi"></div>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="6"
                    class="leftfloat ml1 myzm"
                    v-if="iscodeBtn"
                  >
                    <el-button
                      type="primary"
                      plain
                      @click="sendCodeBtn"
                      v-html="Btn"
                    ></el-button>
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    本系统是工作系统，经常会和作者联系，请填写经常使用的手机号。
                  </div>
                </el-form-item>
                <div v-if="isShows">
                  <el-form-item label="验证码:">
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcodes"
                        placeholder="请输入验证码"
                        @blur="DetectInput($event, 'codes')"
                        @input="DetectKey($event, 'codes')"
                      ></el-input>
                      <div class="msg_error" v-html="codeTishi"></div>
                    </el-col>
                    <el-col
                      :md="6"
                      :lg="6"
                      :xl="6"
                      :sm="6"
                      class="leftfloat ml1 myzm"
                    >
                      <span style="cursor: pointer">
                        <img
                          @click="initVeri()"
                          :src="'data:image/png;base64,' + Picturebase"
                          alt="无效"
                        />
                      </span>
                    </el-col>
                  </el-form-item>
                  <div class="msg_error" v-html="codeTiShis"></div>
                  <div class="twenfive">
                    <div class="msg_error" v-if="statuCf">
                      该手机号已被人注册。如果您确认该手机号是您的手机号，请<a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >找回密码</a
                      >。
                    </div>
                    <div class="msg_error" v-if="statuCfa">
                      该手机号已被人注册。如果您确认该手机号是您的手机号，请您<a
                        href="javascript:;"
                        @click="$router.push('/LookforPassword')"
                        >找回密码</a
                      >或致电页面底部技术支持。
                    </div>
                    <div class="highgreen" v-if="status == 1 && codess">
                      验证码已经发送，请在 10分钟内确认。过期不能注册成功。
                    </div>
                  </div>
                  <div class="twenfive">
                    <el-col
                      :md="10"
                      :lg="10"
                      :xl="10"
                      :sm="10"
                      class="leftfloat ml1 myzm"
                      v-if="iscodeBtna"
                    >
                      <el-button
                        class="five"
                        type="primary"
                        plain
                        @click="sendCodeBtn"
                        v-html="Btn1"
                        style="width: 100%"
                      ></el-button>
                    </el-col>
                    <el-col
                      :md="10"
                      :lg="10"
                      :xl="10"
                      :sm="10"
                      class="leftfloat ml1 myzm"
                    >
                      <el-button
                        class="five"
                        style="width: 100%"
                        v-if="status == 0"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                    </el-col>
                  </div>
                  <template v-if="status == 1">
                    <el-form-item label="验证码:">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="请输入验证码"
                        ></el-input>
                        <div class="msg_error" v-html="codeTishi"></div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="密码:">
                      <el-col
                        :md="14"
                        :lg="14"
                        :xl="14"
                        style="margin-top: 10px"
                      >
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          @blur="DetectInput($event, 'pass')"
                          @input="DetectKey($event, 'pass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="five highgray five" style="zoom: normal">
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）</span
                        >
                      </div>
                      <div class="msg_error" v-html="pwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="确认密码:">
                      <el-col
                        :md="14"
                        :lg="14"
                        :xl="14"
                        style="margin-bottom: 10px"
                      >
                        <el-input
                          v-model="form.rpass"
                          placeholder="请重新键入您的密码"
                          @blur="DetectInput($event, 'rpass')"
                          @input="DetectKey($event, 'rpass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="rpwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="submit()"
                        >提交</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                      <div class="highgreen ten" v-if="showsuess">
                        <i class="el-icon-success"></i>提交成功！
                        <a href="javascript:;" class="highblue ml15"
                          >登录后完善个人信息后，投稿。</a
                        >
                      </div>
                    </el-form-item>
                  </template>
                </div>
              </el-form>
            </el-tab-pane>

            <el-tab-pane label="用户名注册" name="third" class="ten">
              <el-form
                ref="form"
                :model="form"
                label-width="70px"
                class="twenfive"
              >
                <el-form-item label="用户名:">
                  <el-col :md="10" :lg="10" :xl="10" :sm="10">
                    <el-input
                      v-model="form.user"
                      :disabled="isshuru"
                      placeholder="请输入用户名"
                      @blur="DetectInput($event, 'user')"
                      @input="DetectKey($event, 'user')"
                    ></el-input>
                  </el-col>
                  <el-col
                    :md="6"
                    :lg="6"
                    :xl="6"
                    :sm="8"
                    class="leftfloat ml1 myzm"
                    v-if="isshurus"
                  >
                    <el-button type="primary" plain @click="aaa()"
                      >验证该用户名是否可用</el-button
                    >
                  </el-col>
                  <div class="clearfix"></div>
                  <div class="highgray five">
                    用户名长度在4到16位之间，只能输入数字、字母、下划线，不能为纯数字。
                  </div>
                  <!-- <div class="highgreen" v-if="stat == 1">该用户名可用。</div> -->
                  <div class="msg_error" v-html="userTishi"></div>
                </el-form-item>
                <div v-if="isShows">
                  <div v-if="isEmail">
                    <el-form-item label="Email:">
                      <el-col :md="13" :lg="13" :xl="13" :sm="12">
                        <el-input
                          v-model="form.name"
                          placeholder="请输入E-mail"
                          @blur="DetectInput($event, 'emails')"
                          @input="DetectKey($event, 'emails')"
                        ></el-input>
                      </el-col>
                      <el-col
                        :md="6"
                        :lg="6"
                        :xl="6"
                        :sm="6"
                        class="leftfloat ml1 myzm"
                        v-if="iscodeBtn"
                      >
                        <el-button
                          type="primary"
                          plain
                          @click="sendCodeBtn"
                          v-html="Btn"
                        ></el-button>
                      </el-col>
                      <div class="clearfix"></div>
                      <!-- <div class="msg_error" v-html="EmailTiShi"></div>   -->
                    </el-form-item>
                    <div class="clearfix"></div>

                    <div class="highgray five" style="margin-left: 80px">
                      本系统是工作系统，经常会和作者联系，请填写经常使用的邮箱。
                    </div>

                    <el-form-item label="验证码:">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcodes"
                          placeholder="请输入验证码"
                          @blur="DetectInput($event, 'codes')"
                          @input="DetectKey($event, 'codes')"
                        ></el-input>
                      </el-col>
                      <el-col
                        :md="6"
                        :lg="6"
                        :xl="6"
                        :sm="6"
                        class="leftfloat ml1 myzm"
                      >
                        <span style="cursor: pointer">
                          <img
                            @click="initVeri()"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                        </span>
                      </el-col>
                    </el-form-item>
                    <div class="msg_error" v-html="codeTiShis"></div>
                    <div class="clearfix"></div>

                    <div class="twenfive">
                      <div class="msg_error" v-if="statuCf">
                        该邮箱已被人注册。如果您确认该邮箱是您的邮箱，请<a
                          href="javascript:;"
                          @click="$router.push('/LookforPassword')"
                          >找回密码</a
                        >。
                      </div>
                      <div class="msg_error" v-if="statuCfa">
                        该邮箱已被人注册。如果您确认该邮箱是您的邮箱，请您<a
                          href="javascript:;"
                          @click="$router.push('/LookforPassword')"
                          >找回密码</a
                        >或致电页面底部技术支持。
                      </div>
                      <div class="highgreen" v-if="status == 1">
                        系统已经发送验证码到填写的邮箱，若未收到验证码，请到邮件垃圾箱中查找一下。
                      </div>
                    </div>
                    <div class="twenfive">
                      <el-col
                        :md="10"
                        :lg="10"
                        :xl="10"
                        :sm="10"
                        class="leftfloat ml1 myzm"
                        v-if="iscodeBtna"
                      >
                        <el-button
                          class="five"
                          :type="`${this.stat == 0 ? 'default' : 'primary'}`"
                          plain
                          @click="ddd"
                          style="width: 100%"
                          v-html="Btn1"
                          :disabled="this.stat == 0"
                        ></el-button>
                      </el-col>
                      <el-col
                        :md="10"
                        :lg="10"
                        :xl="10"
                        :sm="10"
                        class="leftfloat ml1 myzm"
                      >
                        <el-button
                          class="five"
                          style="width: 100%"
                          v-if="status == 0"
                          @click="$router.push('/')"
                          >取消</el-button
                        >
                      </el-col>
                    </div>
                    <template v-if="status == 1">
                      <el-form-item label="验证码:">
                        <el-col :md="14" :lg="14" :xl="14">
                          <el-input
                            v-model="form.yzcode"
                            placeholder="请输入验证码"
                          ></el-input>
                          <div class="msg_error" v-html="codeTishi"></div>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="密码:">
                        <el-col
                          :md="14"
                          :lg="14"
                          :xl="14"
                          style="margin-top: 10px"
                        >
                          <el-input
                            v-model="form.pass"
                            placeholder="请输入密码"
                            @blur="DetectInput($event, 'pass')"
                            @input="DetectKey($event, 'pass')"
                            show-password
                          ></el-input>
                        </el-col>
                        <div class="clearfix"></div>
                        <div class="five highgray five" style="zoom: normal">
                          <span
                            >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）</span
                          >
                        </div>
                        <div class="msg_error" v-html="pwdTiShi"></div>
                      </el-form-item>
                      <el-form-item label="确认密码:">
                        <el-col
                          :md="14"
                          :lg="14"
                          :xl="14"
                          style="margin-bottom: 10px"
                        >
                          <el-input
                            v-model="form.rpass"
                            placeholder="请重新键入您的密码"
                            @blur="DetectInput($event, 'rpass')"
                            @input="DetectKey($event, 'rpass')"
                            show-password
                          ></el-input>
                        </el-col>
                        <div class="clearfix"></div>
                        <div class="msg_error" v-html="rpwdTiShi"></div>
                      </el-form-item>

                      <el-form-item label="">
                        <el-button
                          style="width: 48%"
                          type="primary"
                          @click="submit()"
                          >提交</el-button
                        >
                        <el-button
                          style="width: 48%"
                          class="ml1"
                          @click="$router.push('/')"
                          >取消</el-button
                        >
                        <div class="highgreen ten" v-if="showsuess">
                          <i class="el-icon-success"></i>提交成功！
                          <a href="javascript:;" class="highblue ml15"
                            >登录后完善个人信息后，投稿。</a
                          >
                        </div>
                      </el-form-item>
                    </template>
                  </div>
                  <div v-if="!isEmail">
                    <el-form-item label="密码:">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          @blur="DetectInput($event, 'pass')"
                          @input="DetectKey($event, 'pass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="five highgray five" style="zoom: normal">
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）</span
                        >
                      </div>
                      <div class="msg_error" v-html="pwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="确认密码:">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.rpass"
                          placeholder="请重新键入您的密码"
                          @blur="DetectInput($event, 'rpass')"
                          @input="DetectKey($event, 'rpass')"
                          show-password
                        ></el-input>
                      </el-col>
                      <div class="clearfix"></div>
                      <div class="msg_error" v-html="rpwdTiShi"></div>
                    </el-form-item>
                    <el-form-item label="验证码:" v-if="codeshow">
                      <el-col :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcodes"
                          placeholder="请输入验证码"
                          @blur="DetectInput($event, 'codes')"
                          @input="DetectKey($event, 'codes')"
                        ></el-input>
                        <div class="msg_error" v-html="codeTiShis"></div>
                      </el-col>
                      <el-col
                        :md="6"
                        :lg="6"
                        :xl="6"
                        :sm="6"
                        class="leftfloat ml1 myzm"
                      >
                        <span style="cursor: pointer">
                          <img
                            @click="initVeri()"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                        </span>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button
                        style="width: 48%"
                        type="primary"
                        @click="submit()"
                        >提交</el-button
                      >
                      <el-button
                        style="width: 48%"
                        class="ml1"
                        @click="$router.push('/')"
                        >取消</el-button
                      >
                      <div class="highgreen ten" v-if="showsuess">
                        <i class="el-icon-success"></i>提交成功！
                        <a href="javascript:;" class="highblue ml15"
                          >登录后完善个人信息后，投稿。</a
                        >
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="login_other fifth" style="margin-top: 15px">
          <p class="text-center" style="color: #9fadc6">
            如已注册账号，请直接<a
              href="javascript:void(0)"
              @click="$router.push('/login')"
              >进行登录</a
            >
          </p>
        </div>

        <p class="text-center" v-if="isweixin || IsQQLogin">
          已经有<span v-if="IsQQLogin">QQ，</span>
          <span v-if="isweixin">微信</span>账号，可直接登录，不用重复注册。
        </p>
        <div class="clearfix"></div>
        <div class="login_other_button">
          <el-button
            v-if="isweixin"
            text
            @click="wxshow()"
            class="weixin"
            ><img src="../../assets/images/add_wx1.png"
          /></el-button>
          <el-dialog
            v-model="dialogVisible"
            width=""
            center
            :before-close="handleClose"
            class="wxcode"
          >
            <div v-loading="loading">
              <p class="mobList eqcode">长按识别二维码注册并登录</p>
              <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>
              <div>
                <img :src="src" width="150" height="150" style="" />
              </div>
            </div>
          </el-dialog>
          <a
            style="cursor: pointer"
            @click="useqqlogin"
            class="qq_login"
            v-if="IsQQLogin"
            ><img src="../../assets/images/add_qq1.png"
          /></a>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          您的密码不符合相关要求，请<router-link
            to="/ChangePassword"
            style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title="验证码验证"
      v-model="isShow"
      custom-class="dialogwidth"
      :show-close="false"
    >
      <el-form>
        <el-form-item>
          <el-col
            :xs="6"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
            style="text-align: right"
            >验证码:&nbsp;&nbsp;</el-col
          >
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <el-input
              v-model="yzcodesss"
              placeholder="请输入验证码"
            ></el-input>
            <div class="msg_error" v-html="phoneTiShis"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
            <span style="cursor: pointer">
              <div
                style="
                  height: 40px;
                  width: 110px;
                  font-size: 22px;
                  padding: 5px;
                "
              >
                <img
                  @click="initVeris()"
                  :src="'data:image/png;base64,' + Picturebases"
                  alt="无效"
                  style="height: 40px; width: 110px"
                />
              </div>
            </span>
          </el-col>
        </el-form-item>
      </el-form>

      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button
            style="margin-top: 10px"
            type="primary"
            @click="bbb($event, 'name')"
            >确 定</el-button
          >
          <el-button @click="ccc">取 消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'
var timeStop
import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
import Login_WeiXin from '../../components/Login/Login_WeiXin'
var time
export default {
  name: 'reg',
  data() {
    return {
      statuCf: false,
      statuCfa: false,
      showWx: false,
      activeName: 'first',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      yzcodesss: '',
      Code: '',
      src: '',
      form: {
        name: '',
        yzcode: '',
        yzcodes: '',
        pass: '',
        rpass: '',
        user: '',
      },
      type: 2,
      types: 0,
      model: '',
      isweixin: false,
      fixmodel: 'EmailBox',
      dialogVisible: false,
      loading: true,
      phoneTiShi: '',
      phoneTiShis: '',
      pwdTiShi: '',
      rpwdTiShi: '',
      EmailTiShi: '',
      codeTishi: '',
      userTishi: '',
      Btn: '发送验证码',
      Btn1: '发送邮箱/手机验证码',
      wait: 60,
      user_type: '',
      status: 0,
      GUID: '',
      stat: 1,
      showsuess: false,
      isphone: false,
      isphones: false,
      Picture: '',
      Pictures: '',
      codeImg: require('../../assets/images/timg.jpg'),
      GUIDS: '',
      codeTiShis: '',
      codeshow: true,
      isEmail: false,
      iscodeBtn: false,
      iscodeBtna: true,
      codess: false,
      pwdFalseShow: false,
      Picturebase: '',
      Picturebases: '',
      GUIDBase: '',
      isShow: false,
      isShows: false,
      isshuru: false,
      isshurus: true,
      ItemCounta: '',
    }
  },
  components: {
    Login_WeiXin,
  },
  created() {
    this.initVeri()
    let params = [
      1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
      4553, 6021, 310, 12,
    ]
    this.$store.dispatch('_getSet', params).then((res) => {
      sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
      let SetItem = res.data.Data
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == '是') {
            this.isphone = true
          } else {
            this.isphone = false
          }
        }
        if (item.SetItemID == 12) {
          if (item.Item_Value == '是') {
            this.isphones = true
          } else {
            this.isphones = false
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == '是') {
            this.isweixin = true
          } else {
            this.isweixin = false
          }
        }
        if (item.SetItemID == 6021) {
          if (item.Item_Value == '是') {
            this.isEmail = true
            this.activeName = 'first'
          } else {
            this.isEmail = false
            this.activeName = 'second'
          }
        }
        if (!this.isphone && !this.isEmail) {
          this.activeName = 'third'
        }
      })
      if (this.isEmail) {
        if (this.isphone) {
          this.type = 2
          this.types = 0
        } else {
          this.type = 2
          this.types = 0
        }
      } else {
        if (this.isphone) {
          this.type = 3
          this.types = 2
        } else {
          this.type = 1
          this.types = 1
        }
      }
    })

    //   }
  },
  methods: {
    async ddd() {
      let res = await this.$store.dispatch('_getRegSendCode', {
        MobileEmail: this.form.name,
        CRCeMethod: 1,
        VCode: this.form.yzcodes,
        Guid: this.GUID,
      })
      if (res.data.IsSuccess) {
        this.codeshow = false
        this.status = 1
        this.iscodeBtn = true
        this.iscodeBtna = false
        this.codess = true
        localStorage.setItem(
          'forgotStaTime',
          parseInt(new Date().getTime() / 1000)
        )
        localStorage.setItem('forgotStaTimeType', this.user_type)
        localStorage.setItem('forgotTemporaryPhoneEmail', this.form.name)
      } else {
        this.initVeri()
        alert(res.data.Message)
      }
    },
    ccc() {
      this.isShow = false
      this.yzcodesss = ''
      this.phoneTiShis = ''
    },
    async aaa() {
      this.stat = 0
      if (this.form.user) {
        //0: Email 1:用户名 2: 手机
        let Type = this.types
        let name = ''
        let names = ''
        names = this.form.user
        name = this.form.user
        if (this.type == 1) {
          if (this.$Bai(names)) {
            this.stat = 0
            return (this.userTishi = '账号不能为空')
          } else if (!this.$base(names, 'name')) {
            this.stat = 0
            return (this.userTishi = '用户名不符合以上规则')
          } else if (!isNaN(names)) {
            this.stat = 0
            return (this.userTishi = '用户名不符合以上规则')
          }
        }
        this.isShow = true
        this.initVeris()
      }
      if (this.form.name) {
        //0: Email 1:用户名 2: 手机
        let Type = this.types
        let name = ''
        let names = ''
        names = this.form.user
        name = this.form.user
        if (this.type == 1) {
          if (this.$Bai(names)) {
            this.stat = 0
            return (this.userTishi = '账号不能为空')
          } else if (!this.$base(names, 'name')) {
            this.stat = 0
            return (this.userTishi = '用户名不符合以上规则')
          } else if (!isNaN(names)) {
            this.stat = 0
            return (this.userTishi = '用户名不符合以上规则')
          }
        }
        this.isShow = true
        this.initVeris()
      }
    },
    async bbb() {
      if (this.types == 1) {
        var names = this.form.user
      }
      if (this.types == 0 || this.types == 2) {
        var names = this.form.name
      }
      if (
        this.yzcodesss == '' ||
        this.yzcodesss == null ||
        this.yzcodesss == undefined
      ) {
        this.phoneTiShis = '验证码不能为空'
        return
      } else {
        if (this.yzcodesss.length < 6) {
          this.phoneTiShis = '请输入正确的验证码'
          return
        } else {
          this.phoneTiShis = ''
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch('_getRegDeteCt', {
        Account: names,
        Type: this.types,
        Guid: this.GUIDS,
        VCode: this.yzcodesss,
      })
      if (res.data.IsSuccess == false) {
        this.phoneTiShis = res.data.Message
        this.initVeris()
      } else {
        this.isShow = false
        this.yzcodesss = ''
        this.phoneTiShis = ''
        this.ItemCounta = res.data.ItemCount
        if (res.data.ItemCount == 1) {
          this.userTishi = '该用户名已被人注册。'
          this.EmailTiShi = '该邮箱已被人注册'
          this.phoneTiShi = '该手机号已被人注册'
          this.stat = 0
        } else {
          this.isShows = true
          this.stat = 1
          this.userTishi = '该用户名可以使用'
          this.EmailTiShi = '该邮箱可以使用'
          this.phoneTiShi = '该手机号可以使用'
          this.isshuru = true
          this.isshurus = false
        }
      }
    },
    async wxshow() {
      this.dialogVisible = true
      let carousel = await this.$store.dispatch('_getGetQrcode')
      if (carousel) {
        this.src = carousel.data.Url
        this.Code = carousel.data.Code
        this.loading = false
        this.handleQrcodeCheck(this.type)
        $emit(this, 'func', this.src)
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch('_getWeiXinLogin', { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true
                return
              }
              this.$message({ message: '登录成功', type: 'success' })
              localStorage.setItem('userInfo', JSON.stringify(res.data.Data))
              var urldomain = '/'
              window.location.href = urldomain
              $emit(this, 'fuab', false)
            }
          })
      }, 2000)
    },
    handleClose(done) {
      done()
      this.dialogVisible = false
      clearInterval(timeStop)
    },
    useqqlogin() {
      var urldz =
        'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=' +
        window.OpenId +
        '&response_type=token&scope=all&redirect_uri=' +
        window.callBackHtp +
        '%2F%23%2Flogin_qq'
      window.location.href = urldz
    },
    handleClick(tab, event) {
      this.codeTiShis = ''
      this.codeshow = true
      if (this.isEmail) {
        if (this.isphones) {
          if (tab.index == 0) {
            this.type = 2
            this.types = 0
            this.model = 'EmailBox'
            this.initVeri()
            this.statuCf = false
            this.statuCfa = false
          } else if (tab.index == 1) {
            this.type = 3
            this.types = 2
            this.model = 'Mobile'
            this.initVeri()
            this.statuCf = false
            this.statuCfa = false
          } else {
            this.type = 1
            this.types = 1
            this.model = 'UserName'
            if (this.isEmail) {
              this.initVeri()
            }
            this.statuCf = false
            this.statuCfa = false
          }
        } else {
          if (tab.index == 0) {
            this.type = 2
            this.types = 0
            this.initVeri()
            this.model = 'EmailBox'
            this.statuCf = false
            this.statuCfa = false
          } else {
            this.type = 1
            this.types = 1
            this.model = 'UserName'
            this.statuCf = false
            this.statuCfa = false
            if (this.isEmail) {
              this.initVeri()
            }
          }
        }
      } else {
        if (this.isphones) {
          if (tab.index == 0) {
            this.type = 3
            this.types = 2
            this.model = 'Mobile'
            this.initVeri()
            this.statuCf = false
            this.statuCfa = false
          } else if (tab.index == 1) {
            this.type = 1
            this.types = 1
            this.model = 'UserName'
            this.initVeri()
            this.statuCf = false
            this.statuCfa = false
          }
        } else {
          if (tab.index == 0) {
            this.type = 1
            this.types = 1
            this.initVeri()
            this.model = 'UserName'
            this.statuCf = false
            this.statuCfa = false
          }
        }
      }

      this.form = {
        name: '',
        yzcode: '',
        pass: '',
        rpass: '',
        user: '',
      }
      this.phoneTiShi = ''
      this.pwdTiShi = ''
      this.rpwdTiShi = ''
      this.EmailTiShi = ''
      this.codeTishi = ''
      this.userTishi = ''
      this.Btn = '发送验证码'
      this.wait = 60
      this.user_type = ''
      this.status = 0
      this.stat = 0
      ;(this.iscodeBtn = false), (this.iscodeBtna = true)
      clearInterval(time)
    },
    getMsgFormSon(data) {
      this.loading = false
      this.wx = data
    },
    dialoga(data) {
      this.dialogVisible = false
    },
    //鼠标离开
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == 'emails') {
        if (this.$Bai(elem.target.value)) {
          return (this.EmailTiShi = '请输入邮箱')
        }
        if (this.$Space(elem.target.value)) {
          return (this.EmailTiShi = '邮箱不能含有空格')
        }

        if (!this.$base(elem.target.value, 'email')) {
          return (this.EmailTiShi = '请输入正确格式的邮箱')
        } else {
          return (this.EmailTiShi = '')
        }
      }
      //   if(type == "codes"){
      // 	  if(this.$Bai(elem.target.value)){
      // 	  return   this.EmailTiShi= "请输入验证码";
      // 	}
      //   }
      if (type == 'phone') {
        if (this.$Bai(elem.target.value)) {
          return (this.phoneTiShi = '请输入手机号码')
        }
        if (this.$Space(elem.target.value)) {
          return (this.phoneTiShi = '手机号不能含有空格')
        }
        if (!this.$base(elem.target.value, 'phone')) {
          return (this.phoneTiShi = '请输入正确格式的手机号码')
        } else {
          return (this.phoneTiShi = '')
        }
      }
      if (type == 'pass') {
        if (this.$Bai(elem.target.value)) {
          return (this.pwdTiShi = '密码不能为空')
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi = '密码不能小于八位字符')
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = '密码不能含有空格')
        } else if (this.$base(elem.target.value, 'aff')) {
          return (this.pwdTiShi = '密码中含有非法字符')
        } else if (!this.$base(elem.target.value, 'pass')) {
          return (this.pwdTiShi =
            '根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）')
        } else {
          this.pwdTiShi = ''
        }
      }
      if (type == 'rpwd') {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = '确认密码不能为空'
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = '确认密码不得少于八位字符'
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = '密码不能含有空格')
        } else if (this.form.pass != this.form.rpass) {
          this.rpwdTiShi = '两次输入密码不同'
        } else {
          this.rpwdTiShi = ''
        }
      }
      if (type == 'user') {
        if (this.$Bai(elem.target.value)) {
          this.userTishi = '账号不能为空'
        } else if (!this.$base(elem.target.value, 'name')) {
          this.userTishi = '用户名不符合以上规则'
        } else if (!isNaN(elem.target.value)) {
          this.userTishi = '用户名不符合以上规则'
        } else {
          this.userTishi = ''
        }
      }
    },
    DetectKey(elem, type) {
      let base = this.base
      if (type == 'phone') {
        this.statuCf = false
        this.statuCfa = false
        return (this.phoneTiShi = '')
      } else if (type == 'code') {
        this.statuCf = false
        this.statuCfa = false
        return (this.codeTiShi1 = '')
      } else if (type == 'pwd') {
        this.statuCf = false
        this.statuCfa = false
        return (this.pwdTiShi = '')
      } else if (type == 'rpwd') {
        this.statuCf = false
        this.statuCfa = false
        return (this.rpwdTiShi = '')
      } else {
        this.statuCf = false
        this.statuCfa = false
        return (this.EmailTiShi = '')
      }
    },
    async sendCodeBtn(elem, str) {
      //点击发送验证码
      //0: Email 1:用户名 2: 手机
      let Type = this.types
      let name = ''
      let names = ''
      var numerr = 0
      let codes = ''

      names = this.form.user
      codes = this.form.yzcodes
      if (str == 'phone') {
        name = this.form.user
        Type = 1
        if (this.$Bai(name)) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = '账号不能为空')
        } else if (!this.$base(name, 'name')) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = '用户名不符合以上规则')
        } else if (!isNaN(name)) {
          numerr = 1
          this.stat = 0
          return (this.userTishi = '用户名不符合以上规则')
        } else {
          this.stat = 1
          numerr = 0
          this.userTishi = ''
        }
      } else {
        name = this.form.name
        if (this.types == 0) {
          if (this.type == 1) {
            if (this.$Bai(names)) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = '账号不能为空')
            } else if (!this.$base(names, 'name')) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = '用户名不符合以上规则')
            } else if (!isNaN(names)) {
              numerr = 1
              this.stat = 0
              return (this.userTishi = '用户名不符合以上规则')
            } else {
              numerr = 0
              this.stat = 1
              this.userTishi = ''
            }
          } else if (this.isEmail) {
            Type = 0
            if (this.type == 2) {
              if (this.$Bai(name)) {
                numerr = 1
                return (this.EmailTiShi = '请输入邮箱')
              }
              if (this.$Space(name)) {
                numerr = 1
                return (this.EmailTiShi = '邮箱不能含有空格')
              }
              if (!this.$base(name, 'email')) {
                numerr = 1
                return (this.EmailTiShi = '请输入正确格式的邮箱')
              } else {
                numerr = 0
                this.EmailTiShi = ''
              }
            }
          }
        } else if (this.types == 2) {
          Type = 2
          if (this.$Bai(name)) {
            numerr = 1
            return (this.phoneTiShi = '请输入手机号码')
          }
          if (this.$Space(name)) {
            numerr = 1
            return (this.phoneTiShi = '手机号不能含有空格')
          }
          if (!this.$base(name, 'phone')) {
            numerr = 1
            return (this.phoneTiShi = '请输入正确格式的手机号码')
          } else {
            numerr = 0
            this.phoneTiShi = ''
          }
        }
        if (codes == '' || codes == null || codes == undefined) {
          this.codeTiShis = '验证码不能为空'
          return
        } else {
          if (codes.length < 6) {
            this.codeTiShis = '请输入正确的验证码'
            return
          } else {
            this.codeTiShis = ''
          }
        }
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return
      }
      //验证email和手机是否注册过
      if (this.ItemCounta == 0) {
        if (this.type == 1 && str == 'phone') {
          return (this.stat = 1)
        }
        if (Type == 0) {
          this.user_type = 1
        } else {
          this.user_type = Type
        }
        this.$store
          .dispatch('_getRegSendCode', {
            MobileEmail: name,
            CRCeMethod: this.user_type,
            VCode: this.form.yzcodes,
            Guid: this.GUID,
          })
          .then((res) => {
            if (res.data.IsSuccess) {
              this.codeshow = false
              this.status = 1
              this.iscodeBtn = true
              this.iscodeBtna = false
              this.timeCode(elem.target)
              this.codess = true
              localStorage.setItem(
                'forgotStaTime',
                parseInt(new Date().getTime() / 1000)
              )
              localStorage.setItem('forgotStaTimeType', this.user_type)
              localStorage.setItem('forgotTemporaryPhoneEmail', this.form.name)
            } else {
              this.initVeri()
              alert(res.data.Message)
            }
          })
      } else if (this.ItemCounta == 1) {
        if (str == 'phone') {
          //this.userTishi = "该账号已被人注册。如果您确认该账号是您的账号，可填写验证码后进行密码重置，找回账号。"
          this.userTishi = '该用户名已被人注册。'
          this.stat = 0
        } else {
          this.status = 2
          this.statuCf = true
        }
      } else {
        if (str == 'phone') {
          this.userTishi =
            '该手机号已被人注册。如果您确认该手机号是您的手机号，请您找回密码或致电页面底部技术支持'
          this.stat = 0
        } else {
          this.status = 2
          this.statuCfa = true
        }
      }
    },
    timeCode(str) {
      //验证码时间定时器
      time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = '重新发送验证码'
          this.wait = 60
          this.codess = false
          clearInterval(time)
        } else {
          this.Btn = '验证码(' + this.wait + ')'
          this.wait--
        }
      }, 1000)
    },
    submit() {
      //提交
      let status = 0
      if (this.isEmail) {
        if (this.$Bai(this.form.yzcode)) {
          status = 1
          this.codeTishi = '验证码不能为空'
        } else if (this.form.yzcode.length != 6) {
          status = 1
          this.codeTishi = '请输入长度为六位的验证码'
        }
      } else {
        status = 0
      }

      if (this.$Bai(this.form.yzcodes)) {
        status = 1
        this.codeTiShis = '验证码不能为空'
      }
      // else{
      // 	if((this.Pictures).toLowerCase() != (this.form.yzcodes).toLowerCase()){
      // 	status=1;
      //     this.codeTiShis="验证码验证失败"
      // }
      // }
      if (this.$Bai(this.form.pass)) {
        status = 1
        this.pwdTiShi = '密码不能为空'
      } else if (this.$Space(this.form.pass)) {
        status = 1
        this.pwdTiShi = '密码不得含有空格'
      } else if (this.$base(this.form.pass, 'aff')) {
        status = 1
        this.pwdTiShi = '密码内含有非法字符'
      } else if (!this.$base(this.form.pass, 'pass')) {
        status = 1
        this.pwdTiShi =
          '根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）'
      }
      if (this.$Bai(this.form.rpass)) {
        status = 1
        this.rpwdTiShi = '确认密码不能为空'
      } else if (this.form.rpass.length < 8) {
        this.rpwdTiShi = '确认密码不得少于八位'
      } else if (this.$base(this.form.rpass, 'aff')) {
        status = 1
        this.rpwdTiShi = '确认密码内含有非法字符'
      } else if (this.$Space(this.form.rpass)) {
        status = 1
        this.rpwdTiShi = '确认密码不得含有空格。'
      } else if (this.form.rpass != this.form.pass) {
        status = 1
        this.rpwdTiShi = '两次输入的密码不一致'
      }

      if (status == 1) {
        return
      }
      this.phoneTiShi = ''
      this.pwdTiShi = ''
      this.rpwdTiShi = ''
      this.EmailTiShi = ''
      this.codeTishi = ''
      let pwm = md5(this.form.pass + '!@*Samson*@!')
      let pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString()
      let data = {}
      if (this.type == 1) {
        data = {
          EmailBox: this.form.name,
          UserName: this.form.user,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode || this.form.yzcodes,
          Pwd: pwm,
        }
      } else if (this.type == 2) {
        data = {
          EmailBox: this.form.name,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode || this.form.yzcodes,
          Pwd: pwm,
        }
      } else {
        if (!this.isEmail) {
          data = {
            Mobile: this.form.name,
            UserName: this.form.user,
            Password: pwaes,
            RegisterMethod: this.type,
            TempGuid: this.GUID,
            Code: this.form.yzcode || this.form.yzcodes,
            Pwd: pwm,
          }
        } else {
          data = {
            Mobile: this.form.name,
            Password: pwaes,
            RegisterMethod: this.type,
            TempGuid: this.GUID,
            Code: this.form.yzcode || this.form.yzcodes,
            Pwd: pwm,
          }
        }
      }
      this.$store
        .dispatch('_postRegist', data)
        .then((res) => {
          if (res.data.IsSuccess) {
            sessionStorage.setItem('text', 1)
            alert('注册成功')
            this.showsuess = true
            window.sessionStorage.setItem('Login', 1)
            this.$router.push('/Login')
          } else {
            alert(res.data.Message)
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    async initVeris() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let resbase = await this.$store.dispatch('_getVerificationcodeImg')
      if (resbase.data.IsSuccess) {
        this.GUIDS = resbase.data.Data.GUID
        this.Picturebases = resbase.data.Data.Picture
      } else {
        console.log(resbase.data.Message)
      }
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      var random_number = Math.floor(Math.random() * (100 + 1))
      let resbase = await this.$store.dispatch('_getVerificationcodeImg')
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID
        this.Picturebase = resbase.data.Data.Picture
      } else {
        console.log(resbase.data.Message)
      }
    },
    randomColor() {
      var col = 'rgb('
      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ','
      }
      col = col.slice(0, -1)
      col += ')'
      return col
    },
  },
  emits: ['func', 'fuab'],
}
</script>

<style scoped>
.dialog-footer {
  text-align: center !important;
}
.el-dialog__body {
  padding: 15px 20px !important;
}
.el-form-item {
  margin-bottom: 0px !important;
}
.dialog-footer .el-button {
  width: 150px;
}
.el-button--primary.is-plain {
  color: #fff;
}
.el-input__inner {
  width: auto;
}
.regist label {
  text-align: right !important;
}
.el-form-item__label {
  text-align: right !important;
}
.table-list {
  padding: 0 5px;
}
@media (max-width: 990px) {
  .regist label {
    text-align: right !important;
  }
}
@media (max-width: 768px) {
  .myzm {
    margin-left: 0;
    margin-top: 5px;
  }
}
::v-deep .dialogwidth {
  width: 22% !important;
}
@media screen and (max-width: 1400px) and (min-width: 768px) {
  ::v-deep .dialogwidth {
    width: 40% !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 440px) {
  ::v-deep .dialogwidth {
    width: 60% !important;
  }
}
@media (max-width: 440px) {
  ::v-deep .dialogwidth {
    width: 80% !important;
  }
  .myzm {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
.el-dialog__footer {
  text-align: center !important;
}
</style>
